module.exports = __webpack_public_path__ + "img/exclamation.238f0808.svg";